import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonGroup, Button, Tooltip, ClickAwayListener } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const TextSelectionTooltip = ({ 
  open, 
  position, 
  selectedText, 
  onClose, 
  onGenerateImagePrompt
}) => {
  if (!open || !selectedText) return null;

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: position.top + 10,
          left: position.left,
          zIndex: 1500,
          backgroundColor: 'black',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
          padding: '5px',
        }}
      >
        <ButtonGroup size="small" variant="text">
          <Tooltip title="Generate an AI image prompt">
            <Button
              onClick={() => onGenerateImagePrompt(selectedText)}
              startIcon={<AutoAwesomeIcon fontSize="small" />}
              sx={{ color: '#fff', fontSize: '0.75rem' }}
            >
              Generate Image Prompt
            </Button>
          </Tooltip>
        </ButtonGroup>
      </Box>
    </ClickAwayListener>
  );
};

TextSelectionTooltip.propTypes = {
  open: PropTypes.bool,
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  selectedText: PropTypes.string,
  onClose: PropTypes.func,
  onGenerateImagePrompt: PropTypes.func
};

export default TextSelectionTooltip;
